export const zh = {
    securityService:'安防服务',
    traceService:'轨迹服务',
    storageService:'云存储服务',
    recoveryService:'数据恢复服务',
    imeiNumber:'IMEI号：',
    currentPackage:'当前套餐',
    remaining:'剩余',
    min:'分钟',
    day:'天',
    strips:'条',
    total1:'共',
    loading:'加载中...',
    continuousAnnualPackage:'连续包年',
    continuousRecording:'连续录音',
    continuousMonthlyPackage:'连续包月',
    oneWeekVIP:'一周VIP',
    packageContent:'套餐内容',
    packageContent1:'1、共赠送无限声音安防时长，一年有效',
    packageContent2:'2、云服务有效期内，声音安防存储有效期90天，云服务过期后30天将清除云存储所有数据，请及时续费，避免造成数据丢失',
    packageContent3:'3、此为虚拟产品，一经售出概不退款',
    packageContent4:'4、此套餐只能用于此设备，切换到其他设备需要重新购买',
    payment:'支付方式',
    weChatPayment:'微信支付',
    alipayPayment:'支付宝支付',
    total:'合计：',
    confirmAndPay:'确认并支付',
}
